import React, { FC } from 'react';
import { InspirationType } from '../../services/apis/inspirations/types';
import InspirationListItem from './InspirationListItem';
import styles from './InspirationList.module.scss';

interface InspirationListProps {
  inspirations: InspirationType[];
}

const InspirationList: FC<InspirationListProps> = props => {
  const { inspirations } = props;

  return (
    <div className={styles.list}>
      {inspirations.map(item => (
        <InspirationListItem key={item.id} inspiration={item} />
      ))}
    </div>
  );
};

export default InspirationList;
